<div class="cryptohero1">
  <div id="app" class="section_home2">
    <div class="container hero-container w-container">
      <div class="div-block-8_home2">
        <h1 data-w-id="4fb8184b-95af-b21b-c77f-3dbfd563e4da" style="opacity:0" class="heading-14-copy">Compra criptomonedas en el exchange más seguro</h1>
        <h1 class="home2_subt">Aquí tú eres el único dueño de tu dinero. Tus cryptos son solo tuyas</h1>
        <a routerLink="/" class="btn-2 home2 w-inline-block mainbutton">
          <div class="text-block-40 home2">Empezar</div>
          <div class="text-block-39"><strong class="bold-text-2 home2"></strong></div>
        </a>
        <div data-w-id="b1b336f5-d683-9f85-5789-bc76ce397062" style="opacity:0" class="hero_license_container">
          <div class="hero_license">
            <div class="hero_license_icons"><img src="/assets/landings/images/european_union.svg" loading="lazy" alt="" class="image-54"><img src="/assets/landings/images/es.svg" loading="lazy" width="201" alt="" class="image-53"><img src="/assets/landings/images/bde_icon.svg" loading="lazy" width="201" alt="" class="image-53 right"></div>
            <div class="hero_license_text">Empresa registrada en el Banco de España con número D803. <a href="https://clientebancario.bde.es/pcb/es/blog/registros-del-banco-de-espana.html" target="_blank" class="know_more">Saber más</a>
            </div>
          </div>
        </div>
        <div class="home2_video glightbox">
          <div data-w-id="7839cd87-69dd-0095-85ff-01e8e763ac55" class="home2_video_icon"></div>
          <div class="home2_video_child"><img src="/assets/landings/images/video_thumb1.png" loading="lazy" sizes="(max-width: 1358px) 81vw, 1100px" srcset="/assets/landings/images/video_thumb1.png 500w, /assets//assets/landings/imageshumb1.png 800w, /assets/landings/assets/landings/imagesg 1080w, /assets/landings/cryptoh/assets/landings/images" alt=""></div>
        </div>
      </div>
      <div class="media-spotlight">
        <div class="text-block-82">Hablan de nosotros</div>
        <div class="div-block-144"><img src="/assets/landings/images/rtve.svg" loading="lazy" width="78" alt="" class="image-23"><img src="/assets/landings/images/business.svg" loading="lazy" width="110" alt="" class="image-23"></div>
      </div>
    </div>
  </div>
</div>
